module.exports = __webpack_public_path__ + "static/img/ecwratio.4e2b824d.svg";